export default "__VITE_ASSET__CsKhgAyS__"